export default "__VITE_ASSET__aNhtMDIP__"